/**
 * Image files in a paste or drop. Reads `items` as well as `files`: Safari and
 * some screenshot tools only put the image in `items`.
 */
export function imageFiles(dt: DataTransfer | null): File[] {
  if (!dt) return [];
  const fromItems = Array.from(dt.items ?? [])
    .filter((i) => i.kind === "file")
    .map((i) => i.getAsFile())
    .filter((f): f is File => !!f);
  return (fromItems.length ? fromItems : Array.from(dt.files ?? [])).filter((f) => f.type.startsWith("image/"));
}

/**
 * Images to attach from a paste. Copies from Word, Excel and the like carry text
 * plus an unnamed picture of it; those paste as text. Copied files (named) and
 * screenshots (no text) attach.
 */
export function pastedImages(dt: DataTransfer | null): File[] {
  const files = imageFiles(dt);
  const text = !!dt?.getData("text/plain").trim();
  if (text && files.every((f) => !f.name || f.name === "image.png")) return [];
  return files;
}

/** A drag that carries files (not text or a link being dragged around the page). */
export const isFileDrag = (dt: DataTransfer | null) => !!dt && Array.from(dt.types).includes("Files");
